import React from "react";

const Exclamation = ({ className = "madie-icon", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={className}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8 14.75C11.7279 14.75 14.75 11.7279 14.75 8C14.75 4.27208 11.7279 1.25 8 1.25C4.27208 1.25 1.25 4.27208 1.25 8C1.25 11.7279 4.27208 14.75 8 14.75ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      />
      <path d="M7.4002 4.66667V8.66667C7.4002 9.03486 7.66882 9.33333 8.00019 9.33333C8.33157 9.33333 8.60019 9.03486 8.60019 8.66667V4.66667C8.60019 4.29848 8.33157 4 8.00019 4C7.66882 4 7.4002 4.29848 7.4002 4.66667Z" />
      <path d="M7.2002 11.1111C7.2002 11.602 7.55837 12 8.00019 12C8.44202 12 8.8002 11.602 8.8002 11.1111C8.8002 10.6202 8.44202 10.2222 8.00019 10.2222C7.55837 10.2222 7.2002 10.6202 7.2002 11.1111Z" />
    </svg>
  );
};

export default Exclamation;
